export const REDIRECT_SOURCES = {
  LANDING_PAGE: 'LANDING_PAGE'
}
